import React from 'react'
import './style_sheets/word_counter.css'
import { useRef, useState, useEffect } from 'react'
import './style_sheets/styleCalculator.css'
import './style_sheets/styleStoppuhr.css'
import './style_sheets/styleSlideshow.css'
import img1 from './grieche.png'
import img2 from './grieche 2.png'
import img3 from './grieche 3.png'
import img4 from'./grieche 4.png'
import img5 from './grieche 5.png'
import img6 from './grieche 6.png'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import './style_sheets/styleTicTacToe.css'
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import StopWatch from "./StopWatch"


const myStyle = {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    color:"lightgrey"
}
const myBackground = {
    height: "auto",
    width: "100%"
}

const my_new_background = {
    backgroundColor: "rgb(24, 20, 20)"
}


const Projects = () => {
    /*const ref = useRef(null);
    useEffect(()=>{
        let count = document.getElementById("count");
        console.log("Value of Count is:" + count);
    
        let input = document.getElementById("input");
        console.log("Value of Input is:" + input);
        
    }, []);*/


    return (
        <div style={my_new_background}>
            <h1 style={myStyle}>JavaScript Projekte</h1>
            <p style={myStyle} >Auf dieser Webseite sind ein paar kleine Projekte zu sehen, die ich zuerst mit HTML, CSS sowie JavaScript erstellt habe und anschließend mit React.js auf dieser Seite umgesetzt habe.</p>
            <hr style={{color:"lightgrey"}}/>
            {/* Word Counter JavaScript Projekt in React umgeändert */}
           <Wordcounter/>
            {/* Calculator Javascript Projekt in React umgesetzt */}
            <hr style={{color:"lightgrey"}}/>
            <Calculator/>   
             {/* Slideshow Javascript Projekt in React umgesetzt */}
             <hr style={{color:"lightgrey"}}/>
            <Slide_Show/>
             {/* TicTacToe Javascript Projekt in React umgesetzt */}
             <hr style={{color:"lightgrey"}}/>
            <TicTacToe/> 
            <hr style={{color:"lightgrey"}}/>            
            <StopWatch/>   
            
            {/*<Stopwatch/>*/}
            <Portfolio_Footer/>
        </div>
    )
    
}

function Calculator(){
    const [str, setStr] =useState("");
    return (
        <div className='container'>
            <h2 style={myStyle} >Taschenrechner</h2>
			<div id="resultArea">
                {str}
    		</div>
            <table>
                <tr>
                    <td className='calc' onClick={()=>{setStr(str + "7")}} >7</td>                        
                    <td className='calc' onClick={()=>{setStr(str + "8")}}  >8</td>
                    <td className='calc' onClick={()=>{setStr(str + "9")}}  >9</td>
                    <td id='calc' onClick={()=>{setStr(str + " - ")}} className="ops">-</td>
                </tr>
                <tr>
                    <td className='calc' onClick={()=>{setStr(str + "4")}} >4</td>
                    <td className='calc' onClick={()=>{setStr(str + "5")}}>5</td>
                    <td className='calc' onClick={()=>{setStr(str + "6")}}>6</td>
                    <td id='calc' onClick={()=>{setStr(str + " + ")}} className="ops" >+</td>
                </tr>
                <tr>
                    <td className='calc' onClick={()=>{setStr(str + "1")}}>1</td>
                    <td className='calc' onClick={()=>{setStr(str + "2")}}>2</td>
                    <td className='calc' onClick={()=>{setStr(str + "3")}}>3</td>                        
                    <td id='calc' onClick={()=>{setStr(str + " * ")}} className="ops" >*</td>
                </tr>
                <tr>
                    <td className='calc' onClick={()=>{setStr(str + "0")}}>0</td>
                    <td className='calc' onClick={()=>{setStr(str + ".")}}>.</td>
                    <td className='calc' onClick={()=>{setStr(eval(str))}} id="equ" >=</td>                        
                    <td id='calc' onClick={()=>{setStr(str + " / ")}} className="ops">/</td>
                </tr>
                <tr>
                    <td className='del' onClick={()=>{setStr("")}} >DEL</td>
                </tr>    
            </table>
		</div>
    );
}
let counter_val = 0;
function TicTacToe(){
    
    const [x1, setX1] = useState("");
    const [x2, setX2] = useState("");
    const [x3, setX3] = useState("");
    const [x4, setX4] = useState("");
    const [x5, setX5] = useState("");
    const [x6, setX6] = useState("");
    const [x7, setX7] = useState("");
    const [x8, setX8] = useState("");
    const [x9, setX9] = useState("");
    let test_val = 0;
    function change_val(val){
        if(val === -1){
            setX1("");
            setX2("");
            setX3("");
            setX4("");
            setX5("");
            setX6("");
            setX7("");
            setX8("");
            setX9("");
        }
        if(counter_val == 0){
            if(val == 1){
                setX1("X");
                counter_val = counter_val + 1; 
            }
            if(val == 2){
                setX2("X");
                counter_val = counter_val + 1; 
            }
            if(val == 3){
                setX3("X");
                counter_val = counter_val + 1; 
            }
            if(val == 4){
                setX4("X");
                counter_val = counter_val + 1; 
            }
            if(val == 5){
                setX5("X");
                counter_val = counter_val + 1; 
            }
            if(val == 6){
                setX6("X");
                counter_val = counter_val + 1; 
            }
            if(val == 7){
                setX7("X");
                counter_val = counter_val + 1; 
            }
            if(val == 8){
                setX8("X");
                counter_val = counter_val + 1; 
            }
            if(val == 9){
                setX9("X");
                counter_val = counter_val + 1; 
            }
        }
        else if(counter_val === 1){
            if(val == 1){
                setX1("O");
                counter_val = counter_val + 1; 
            }
            if(val == 2){
                setX2("O");
                counter_val = counter_val + 1; 
            }
            if(val == 3){
                setX3("O");
                counter_val = counter_val + 1; 
            }
            if(val == 4){
                setX4("O");
                counter_val = counter_val + 1; 
            }
            if(val == 5){
                setX5("O");
                counter_val = counter_val + 1; 
            }
            if(val == 6){
                setX6("O");
                counter_val = counter_val + 1; 
            }
            if(val == 7){
                setX7("O");
                counter_val = counter_val + 1; 
            }
            if(val == 8){
                setX8("O");
                counter_val = counter_val + 1; 
            }
            if(val == 9){
                setX9("O");
                counter_val = counter_val + 1; 
            }
        }
        else if(counter_val > 0 && counter_val % 2=== 0){
            if(val == 1){
                setX1("X");
                counter_val = counter_val + 1; 
            }
            if(val == 2){
                setX2("X");
                counter_val = counter_val + 1; 
            }
            if(val == 3){
                setX3("X");
                counter_val = counter_val + 1; 
            }
            if(val == 4){
                setX4("X");
                counter_val = counter_val + 1; 
            }
            if(val == 5){
                setX5("X");
                counter_val = counter_val + 1; 
            }
            if(val == 6){
                setX6("X");
                counter_val = counter_val + 1; 
            }
            if(val == 7){
                setX7("X");
                counter_val = counter_val + 1; 
            }
            if(val == 8){
                setX8("X");
                counter_val = counter_val + 1; 
            }
            if(val == 9){
                setX9("X");
                counter_val = counter_val + 1; 
            }
        }
        else if(counter_val !== 0 && counter_val % 2=== 1){
            if(val == 1){
                setX1("O");
                counter_val = counter_val + 1; 
            }
            if(val == 2){
                setX2("O");
                counter_val = counter_val + 1; 
            }
            if(val == 3){
                setX3("O");
                counter_val = counter_val + 1; 
            }
            if(val == 4){
                setX4("O");
                counter_val = counter_val + 1; 
            }
            if(val == 5){
                setX5("O");
                counter_val = counter_val + 1; 
            }
            if(val == 6){
                setX6("O");
                counter_val = counter_val + 1; 
            }
            if(val == 7){
                setX7("O");
                counter_val = counter_val + 1; 
            }
            if(val == 8){
                setX8("O");
                counter_val = counter_val + 1; 
            }
            if(val == 9){
                setX9("O");
                counter_val = counter_val + 1; 
            }
        }else{
            console.log("false")
        }
    }
    function alert_func_X(){
        alert("Player with X is the Winner! Click RESTART button to start a new Game!");
    }
    function alert_func_O(){
        alert("Player with O is the Winner! Click RESTART button to start a new Game!");
    }
    let timeout;
    function waiting_function_X(){
        timeout = setTimeout(alert_func_X, 500);
    }
    function waiting_function_O(){
        timeout = setTimeout(alert_func_O, 500);
    }
    function check(){
        if(x1 ==="X" && x2==="X" && x3==="X"){
            waiting_function_X();
        }
        if(x4 ==="X" && x5==="X" && x6==="X"){
            waiting_function_X();
        }
        if(x7 ==="X" && x8==="X" && x9==="X"){
            waiting_function_X();
        }
        if(x1 ==="X" && x5==="X" && x9==="X"){
            waiting_function_X();
        }
        if(x3 ==="X" && x5==="X" && x7==="X"){
            waiting_function_X();
        }
        if(x1 ==="X" && x4==="X" && x7==="X"){
            waiting_function_X();
        }
        if(x2 ==="X" && x5==="X" && x8==="X"){
            waiting_function_X();
        }
        if(x3 ==="X" && x6==="X" && x9==="X"){
            waiting_function_X();
        }
        


        if(x1 ==="O" && x2==="O" && x3==="O"){
            waiting_function_O();
        }
        if(x4 ==="O" && x5==="O" && x6==="O"){
            waiting_function_O();
        }
        if(x7 ==="O" && x8==="O" && x9==="O"){
            waiting_function_O();
        }
        if(x1 ==="O" && x5==="O" && x9==="O"){
            waiting_function_O();
        }
        if(x3 ==="O" && x5==="O" && x7==="O"){
            waiting_function_O();
        }
        if(x1 ==="O" && x4==="O" && x7==="O"){
            waiting_function_O();
        }
        if(x2 ==="O" && x5==="O" && x8==="O"){
            waiting_function_O();
        }
        if(x3 ==="O" && x6==="O" && x9==="O"){
            waiting_function_O();
        }
        
    }

    return(
        <div>
            <h2 style={myStyle}>Tic Tac Toe</h2>
            <div className='container' id="TicTacToe">
                <div className="game-field">
                    <table className="game-table" onChange={check()}>
                        <tr id="row-1">
                            <td className='tic' onClick={()=>{
                                console.log(counter_val);
                                change_val(1);
                                }} id="1">{x1}</td>

                                <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(2);
                                }} id="2">{x2}</td>

                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(3);
                                }} id="3">{x3}</td>
                        </tr>
                        <tr id="row-2">
                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(4);
                                }} id="4">{x4}</td>
                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(5);
                                }} id="5">{x5}</td>
                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(6);
                                }} id="6">{x6}</td>
                        </tr>
                        <tr id="row-3">
                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(7);
                                }} id="7">{x7}</td>
                            <td className='tic' onClick={()=>{
                                    console.log(counter_val);
                                    change_val(8);
                                }} id="8">{x8}</td>
                            <td className='tic' onClick={()=>{
                                       console.log(counter_val);
                                       change_val(9);
                                }} id="9">{x9}</td>
                        </tr>
                    </table>
                    
                </div>
                <div id='restart'><button onClick={()=>{
                    change_val(-1);
                }}>RESTART</button></div>
            </div>
        </div>
    )
}


function Wordcounter(){
    
    const [count, setCount] = useState(0);
    const [countChar, setCountChar] = useState(0);
    let word_length = 0;
    const changeHandler = e =>{
        e.preventDefault()
        let x = inputRef.current.value;
        let y = x.split(" ");
        let num_spaces = 0;
        for(let i=0; i<x.length; i++){
            if(y[i] ===""){
                num_spaces = num_spaces+1;
            }
        }
        console.log("Value of Input is:" + inputRef.current.value);
        console.log("Number of Words = " + y.length);
        word_length = y.length - num_spaces;
        num_spaces = 0;
        if(word_length >= 1){
            setCount(word_length);
        }
        if(x==""){
            setCount(0);
        }
        let z = inputRef.current.value;
        setCountChar(z.length);
        
    }

    const word_counter_style = {
        marginBottom: "50px"
    }


    let inputRef = useRef(null);
    return(
        <div>
            {/* Word Counter JavaScript Projekt in React umgeändert */}
            <div className="ui-input-container" style={word_counter_style}>
                <h2>Word Counter</h2>
                <form onChange={changeHandler}>
                    <label className="ui-form-input-container" >
                        <input className ="ui-form-input" ref={inputRef} id="input"></input>
                        <span className="form-input-label">Message</span>
                    </label>
                </form>
                <p aria-live="polite">
                    <strong>
                        <span id="count">{count}</span> words
                    </strong> | 
                    <strong>
                        <span id="character">{countChar}</span> characters (with special characters)
                    </strong>.
                </p>
		    </div>
        </div>
    )
}

function Slide_Show(){
    
    const properties = {
        duration: 5000,
        transitionDuration: 500,
        infinite: true,
        indicators: true,
        arrows: true
    }
    return(
        <div className='container'>
            <div className="containerSlide">
                <h2 style={myStyle}>Webseite für einen Griechen in der Stadt Neuruppin (angezeigt als Slideshow)</h2>
                <Slide {...properties}>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img1}/>
                        </div>
                    </div>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img2}/>
                        </div>
                    </div>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img3}/>
                        </div>
                    </div>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img4}/>
                        </div>
                    </div>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img5}/>
                        </div>
                    </div>
                    <div className='each-slide'>
                        <div>
                            <img className='greek' src={img6}/>
                        </div>
                    </div>
                </Slide>
                
            </div>
        </div>
    )
}


function Portfolio_Footer(){
    return(
        <MDBFooter bgColor='dark' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>

        Melden Sie sich bei mir, wenn Ihnen mein Portfolio gefällt.
        
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-2" />
                Portfolio Adrian Dröse
              </h6>
              <p>
                Kontaktieren Sie mich unter der angegebenen E-Mail oder per Telefon. Besuchen Sie bei Interesse außerdem meine Github-Seite, wo Sie Programme finden können, die ich im Laufe meines Studiums geschrieben habe.
              </p>
              
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Kontakt</h6>
              
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                droese.websites@gmail.com
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                adrian.droese@web.de
              </p>
              
              <p>
                {/*<MDBIcon icon="github" className="me-2" /> https://github.com/businesswebsites*/}
                <a className="me-2 text-reset fw-bold" href='https://github.com/businesswebsites' >Github</a>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2022 Copyright:
        <a className='text-reset fw-bold' href='https://businesswebsites.github.io/portfolio/'>
        https://businesswebsites.github.io/portfolio/
        </a>
      </div>
    </MDBFooter>
    )
}









export default Projects